import React from 'react';
import { Col, Row, Button } from 'antd';
import styles from './index.less';
import { CommonSectionLayout } from 'src/components/POSWebsite/legacy';
import { FormattedMessage, useIntl } from 'react-intl';
import { JoinClassName } from 'src/utils/utils';
import { useRouter } from 'next/router';
import ContentfulRichText from '../ContentfulRichText';
import Link from 'next/link';

const FeaturedArticle = ({ article }) => {
  let intl = useIntl();
  const router = useRouter();

  const featureImage = article?.fields?.featureImage || null;
  const onPreviewClick = () => {
    router.push('/blog/article/[article]', `/blog/article/${article.fields.urlTitle}`);
  };

  if (!article) {
    return null;
  }

  return (
    <React.Fragment>
      {article && (
        <div className={JoinClassName(styles.featuredArticle)}>
          <CommonSectionLayout backgroundColor="#ffffff" title={''} description={''}>
            <Row gutter={[{ xs: 0, sm: 8, md: 16 }, 16]} style={{ marginTop: '20px' }}>
              <Col xs={24} sm={24} md={12} lg={12}>
                <img
                  src={featureImage.fields.file.url}
                  alt={featureImage.fields.title}
                  className={JoinClassName(styles.featuredImage)}
                />
              </Col>
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                style={{ paddingTop: '1rem', paddingBottom: '1rem', paddingLeft: '2rem', paddingRight: '2rem' }}
              >
                <div className={JoinClassName(styles.featuredArticleTitle)}>
                  <span>{article.fields.title}</span>
                </div>
                <div className={JoinClassName(styles.featuredArticlePreviewText)}>
                  <ContentfulRichText document={article.fields.previewText} />
                </div>
                <div className={JoinClassName(styles.featuredArticlePreviewBottom)}>
                  <Button type="primary" className={JoinClassName(styles.featuredArticleReadMore)}>
                    <Link
                      href="/blog/article/[article]"
                      as={`/blog/article/${article.fields.urlTitle}`}
                      onClick={onPreviewClick}
                    >
                      {intl.formatMessage({ id: 'home.blog.readmore.button' })}
                    </Link>
                  </Button>
                </div>
              </Col>
            </Row>
          </CommonSectionLayout>
        </div>
      )}
    </React.Fragment>
  );
};

export default FeaturedArticle;
